import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyAUQ67LGxwH2kC0jQSqXIISHlwLs1wZ7Wo',
  authDomain: 'auction-platform-40910.firebaseapp.com',
  projectId: 'auction-platform-40910',
  storageBucket: 'auction-platform-40910.appspot.com',
  messagingSenderId: '894444722746',
  appId: '1:894444722746:web:4612a789848780ccf5b303',
}

firebase.initializeApp(config)
firebase.analytics()

export const auth = firebase.auth()
export const storage = firebase.storage().ref()
export const firestore = firebase.firestore()

export default firebase
